import {httpsCallable} from "firebase/functions";
import {functions} from "../Security/firebase-config";
import {FUNCTION_NAMES} from "./functionNames";

export const TEAM_QUOTA_REFRESH_EVENT = "team-quota-refresh";

export async function checkTeamQuotaAllowance({
  teamId,
  action,
  bytesToAdd = 0,
}) {
  const callableName = FUNCTION_NAMES.checkTeamQuotaAllowance || "checkTeamQuotaAllowanceV2";
  const callable = httpsCallable(functions, callableName);
  const response = await callable({
    teamId,
    action,
    bytesToAdd,
  });

  return response?.data || null;
}

export function triggerTeamQuotaRefresh(teamIdOrPayload) {
  if (typeof window === "undefined") return;

  const detail =
    typeof teamIdOrPayload === "string"
      ? {teamId: teamIdOrPayload}
      : teamIdOrPayload && typeof teamIdOrPayload === "object"
      ? teamIdOrPayload
      : null;

  if (!detail?.teamId) return;

  if (typeof detail.bytesDelta !== "number") {
    if (typeof detail.bytesAdded === "number") {
      detail.bytesDelta = detail.bytesAdded;
    } else if (typeof detail.bytesRemoved === "number") {
      detail.bytesDelta = -Math.abs(detail.bytesRemoved);
    }
  }

  window.dispatchEvent(new CustomEvent(TEAM_QUOTA_REFRESH_EVENT, {
    detail,
  }));
}

export async function confirmTrackedUploadFinalize({
  teamId,
  objectPath,
}) {
  const callableName =
    FUNCTION_NAMES.confirmTrackedUploadFinalize || "confirmTrackedUploadFinalizeV2";
  const callable = httpsCallable(functions, callableName);
  const response = await callable({
    teamId,
    objectPath,
  });

  return response?.data || null;
}

export async function reconcileTeamQuota({
  teamId,
}) {
  const callableName = FUNCTION_NAMES.reconcileTeamQuota || "reconcileTeamQuotaV2";
  const callable = httpsCallable(functions, callableName);
  const response = await callable({
    teamId,
  });

  return response?.data || null;
}
